import React from 'react';
import { observer } from 'mobx-react';
import { theme } from 'antd';
import type { MenuProps } from 'antd';
import { useStores } from '@/hooks/use-stores';
import { MenuType } from '@/store/PIDEditing/PIDEditStore';
import { getMenuItems } from './AddDeviceMenu.utils';
import { SelectDropdownStyle, StyledDropdown } from './AddDeviceMenu.styles';
import { useTranslation } from 'react-i18next';

const { useToken } = theme;
const AddDeviceMenu: React.FC = observer(() => {
  const { pidEditStore, stationStore } = useStores();
  const { activeMenu } = pidEditStore;
  const { token } = useToken();
  const { t } = useTranslation();

  if (!activeMenu || activeMenu.type !== MenuType.AddDevice || !pidEditStore.isInEditMode) return null;

  const handleMenuClick: MenuProps['onClick'] = ({ key }) => {
    const isMultipleConnections = pidEditStore.isMultipleConnections && pidEditStore.connectedSourceDevices.length > 1;
    if(isMultipleConnections) {
      pidEditStore.showMenu(MenuType.ConnectionPicker, activeMenu.position, { deviceType: key });
    } else {
      pidEditStore.showMenu(MenuType.CreateDevice, activeMenu.position, { deviceType: key });
    }

  };

  const items = getMenuItems(token, t, stationStore);

  return (
    <>
      <SelectDropdownStyle />
      <StyledDropdown
        position={activeMenu.position}
        open
        menu={{ items: items, onClick: handleMenuClick }}
        trigger={['click']}
        placement="bottomLeft"
      />
    </>
  );
});

export default AddDeviceMenu;
